export default __webpack_public_path__ + "static/media/usa.9a3d171e.svg";